import { container, singleton } from "tsyringe";
import UpcomingActionApi from "api/clapaction/projects/[id]/config/UpcomingActionApi";
import UpcomingActionRequestResource from "common/resources/Project/Config/UpcomingAction/UpcomingActionRequestResource";
import UpcomingActionResponseResource from "common/resources/Project/Config/UpcomingAction/UpcomingActionResponseResource";
import toValidationError from "utils/toValidationError";

@singleton()
export default class UpcomingActionService {
	private api: UpcomingActionApi = container.resolve(UpcomingActionApi);

	/**
	 * @description Get all by project id
	 */
	public async getAllByProjectId(projectId: string): Promise<UpcomingActionResponseResource[]> {
		return this.api.getAllByProjectId(projectId).catch(toValidationError);
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, upcomingActionId: string): Promise<UpcomingActionResponseResource> {
		return this.api.getById(projectId, upcomingActionId).catch(toValidationError);
	}

	/**
	 * @description Download upcoming action image
	 */
	public async downloadImage(projectId: string, upcomingActionId: string): Promise<Blob> {
		return this.api.downloadImage(projectId, upcomingActionId).catch(toValidationError);
	}

	/**
	 * @description Create a new upcoming action for a project
	 */
	public async create(projectId: string, request: UpcomingActionRequestResource, image?: File): Promise<UpcomingActionResponseResource> {
		return this.api.create(projectId, request, image).catch(toValidationError);
	}

	/**
	 * @description Update an upcoming action for a project
	 */
	public async update(projectId: string, upcomingActionId: string, request: UpcomingActionRequestResource, image?: File): Promise<UpcomingActionResponseResource> {
		return this.api.update(projectId, upcomingActionId, request, image).catch(toValidationError);
	}

	/**
	 * @description Delete an upcoming action for a project
	 */
	public async delete(projectId: string, upcomingActionId: string): Promise<void> {
		return this.api.delete(projectId, upcomingActionId).catch(toValidationError);
	}
}
